import React from 'react'
import CommunityFormCard, {
  CommunityFormCardVariants,
} from '../Card/CommunityFormCard'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import EmptyPage from '../Elements/EmptyPage'
import { useCommunitiesContext } from '../Context/CommunitiesContext'
import { LoadingContext } from '../Context/LoadingContext'
import { OperationIds } from '../../swagger/operationIdEnum'

export const CommunityDetailsTab: React.FunctionComponent = () => {
  const { t } = useTranslation()

  const {
    academicYear,
    communityDetails,
    handleCancel,
    resetFieldsForCancel,
    communityAbility,
  } = useCommunitiesContext()
  const { loadingIds } = React.useContext(LoadingContext)

  const noCommunityDetailsMessage = (
    <Typography
      variant="subtitle1"
      component="p"
      style={{ whiteSpace: 'pre-line' }}
    >
      {t(
        'Communities.CommunityDetails.NoDetails',
        'Program enrollment not found.\nPlease complete enrollment to view Communities.'
      )}
    </Typography>
  )
  const isLoading = loadingIds.has(OperationIds.FetchCommunity)
  const hasStartedFetch = isLoading || !!communityDetails
  if (!hasStartedFetch) {
    // before loadingId gets enqueued: render spinner
    return <EmptyPage isLoading message={noCommunityDetailsMessage} />
  }
  if (!communityDetails) {
    return (
      <EmptyPage isLoading={isLoading} message={noCommunityDetailsMessage} />
    )
  }

  return (
    <CommunityFormCard
      key={communityDetails.communityKey}
      title={t(
        'Communities.CommunityDetails.FormCard.Header',
        'Community Details'
      )}
      variant={CommunityFormCardVariants.EditCommunity}
      communityDetails={communityDetails}
      communityAbility={communityAbility}
      academicYear={academicYear}
      resetFieldsForCancel={resetFieldsForCancel}
      handleCancel={handleCancel}
    />
  )
}

export default CommunityDetailsTab
